import { Facade, vservice } from '@niknevis/vue-modules'
import { WriterWalletRoute } from '@/modules/wallet/routes/writer-wallet.route'
import Dialog from 'quasar/src/plugins/Dialog.js';
import WalletConfirmDialog from '../components/writer/WalletConfirmDialog.vue'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'


@vservice()
export class WriterWalletService {
  constructor(
    private readonly routes: WriterWalletRoute
  ) {
  }

  update(userId: number, wallet /*:WalletForm*/) {
    return Inertia.put(
      this.routes.wallet(userId),
      wallet
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: WalletConfirmDialog,
        wallet
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }
}

export class Wallet extends Facade<WriterWalletService>() {
  static getFacadeAccessor() {
    return WriterWalletService
  }
}
